module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/forms-pattern-create-overview.json
// module id = 2126
// module chunks = 165595629129438